import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GooglePlaceDirective } from 'ngx-google-places-autocomplete';
import { Address } from 'ngx-google-places-autocomplete/objects/address';
import { ADDRESS_BY_CITY } from 'src/app/core/constants/app-constants';





@Component({
  selector: 'app-address-search-modal',
  templateUrl: './address-search-modal.component.html',
  styleUrls: ['./address-search-modal.component.scss'],
})
export class AddressSearchModalComponent implements OnInit {
  @ViewChild('placesRefAdd', { static: false }) placesRef: GooglePlaceDirective;
  @ViewChild('inputValue', { static: false }) inputValue: ElementRef;
  inputLength = ''
  lat: number
  lng: number
  addressOptionsCity = ADDRESS_BY_CITY;


  constructor(public activeModal: NgbActiveModal) {
  }
ngOnInit() {
  console.log(this.placesRef)  
}
  onKeyUp() {
    this.inputLength = this.inputValue.nativeElement.value
    console.log(this.inputValue.nativeElement.value)
  }
  handleAddressChange(address: Address, proceed: boolean) {
    // const inputValue = this.inputValue.nativeElement.value
    const res = {
      address: address,
      inputValue : this.inputValue.nativeElement.value
    }
    this.activeModal.close(res)
   }


}
